import { render, staticRenderFns } from "./TokenLoad.vue?vue&type=template&id=99159c3c&scoped=true&"
import script from "./TokenLoad.vue?vue&type=script&setup=true&lang=ts&"
export * from "./TokenLoad.vue?vue&type=script&setup=true&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "99159c3c",
  null
  
)

export default component.exports